
const data = [
    {id:1, link:"/" , title:"Home"},
    {id:2, link:"#about" , title:"About"}, 
     {id:3, link:"#techstack" , title:"Tech Stack"},
     {id:4, link:"#Project" , title:"Project"},
    {id:5, link:"#state" , title:"Git State"},
    {id:6, link:"#contact" , title:"Contact"}


]
export default data